<template>
  <div class="filter">
    <div class="item mb20">
      <div class="left">
        <span class="title">
          {{`${$_syscfg.interview}日期`}}
        </span>
        <date-picker :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
      </div>
      <p class="createBtn" @click="goNew()" v-if="showCreate">
        <img src="../assets/img/interview/create.svg" alt="create">
        <span>{{`新建${$_syscfg.interview}`}}</span>
      </p>
    </div>
    <div class="items" v-for="(f, fi) in filters" :key="fi">
      <div class="item">
        <div class="left">
          <span :title="f.title" class="title">
            {{f.title}}
          </span>
          <p :class="{selectors: true, overflow: f.expand}" :ref="`items${fi}`">
            <span :class="{active: i.selected, selector: true}" v-for="(i, d) in f.list" :key="d" @click="selectStatus(f, i)">
              {{i.title}}
            </span>
          </p>
          <div class="expander" @click="changeExpand(f, `items${fi}`)" :ref="`expander${fi}`" v-show="checkEleHeight(`items${fi}`, `expander${fi}`)">
            <img :src="f.expand ? icons.upward : icons.downward" alt="icon">
          </div>
        </div>
      </div>
      <div class="item" v-for="(c, ci) in f.list" :key="ci" v-show="c.list && c.list.length > 0 && c.selected">
        <div class="left">
          <span :title="c.title" class="title">
            {{c.title}}
          </span>
          <p class="selectors">
            <span :class="{active: q.selected, selector: true}" v-for="(q, qi) in c.list" :key="qi" @click="selectStatus(c, q)">
              {{q.title}}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import common from '@common/common'

export default {
  name: 'interviewFilter',
  components: {
    DatePicker
  },
  data() {
    return {
      datePicker: '',
      filters: [],
      start: '',
      end: '',
      icons: {
        downward: require('@assets/img/common/xiala.svg'),
        upward: require('@assets/img/common/upward.svg')
      }
    }
  },
  props: {
    showCreate: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n) {
        this.$parent.page.pageIndex = 1
        this.start = common.stampToTime(n[0])
        this.end = common.stampToTime(n[1])
        this.emitData()
      }
    }
  },
  methods: {
    changeExpand(c, key) {
      // 切换类目展开／收起
      this.$set(c, 'expand', !c.expand)

      this.$nextTick(() => {
        if (!c.expand) {
          this.$refs[key][0].scrollTop = 0
        }
      })
    },
    checkEleHeight(items, expander) {
      // 为实现页面加载后检测是否有换行出现，只能操作dom。里面夹带了具体样式数值
      setTimeout(() => {
        let overflow = false
        const height = this.$refs[items][0].getBoundingClientRect().height

        if (height > 42) {
          overflow = true
        }

        if (overflow) {
          this.$refs[items][0].style.height = '42px'
          this.$refs[expander][0].style.display = 'flex'
        }

        return overflow
      }, 0)
    },
    selectStatus(f, i) {
      // 选择过滤条件
      if (i.selected) return

      this.$parent.page.pageIndex = 1

      f.list.forEach((l) => {
        l.selected = false
      })

      this.$set(i, 'selected', true)
      this.$nextTick(() => {
        this.emitData()
      })
    },
    goNew() {
      // 跳转新建采访
      // this.$router.push({
      //   path: '/newInterview'
      // })

      common.jump('/newInterview', true)
    },
    getData(data) {
      // 接收过滤条件数据
      this.filters = data
    },
    emitData() {
      // 向外传递组件数据
      const data = {}
      this.filters.forEach((i) => {
        i.list.forEach((l) => {
          if (l.selected) {
            if (!l.list || l.list.length === 0)  {
              data[i.key] = l.key
            } else {
              const keyArr = []
              keyArr.push(l.key)

              l.list.forEach(c => {
                if (c.selected) {
                  keyArr.push(c.key)
                }
              })
              
              data[i.key] = keyArr.join(',')
            }
          }
        })
      })
      data['start'] = this.start
      data['end'] = this.end

      this.$emit('getData', data)
    },
    getToday() {
      // 获取当日时间戳
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day} 00:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 23:59:59`)

      return [startSec, endSec]
    },
    initDate() {
      // 默认选中当日时间
      const today = this.getToday()

      this.datePicker = today
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/global.less';

  .filter {
    padding: 0 30px 40px;
    .mb20 {
      margin-bottom: 20px;
    }
    .items:last-child {
      .item:last-child {
        margin: 0;
      }
    }
    .item {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 20px;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: flex-start;
      }
      .title {
        height: 30px;
        line-height: 30px;
        color: @sub;
        font-size: 13px;
        // width: 52px;
        width: 72px;
        text-align-last: justify;
        -webkit-align-last: justify;
        -moz-text-align-last: justify;
        -ms-text-align-last: justify;
        margin: 0 30px 10px 0;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        font-weight: bold;
        color: @green;
      }
      .datePicker {
        display: flex;
        align-items: center;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
        height: 28px;
        padding: 0 10px;
        color: @dateColor;
        span {
          margin: 0 40px;
          cursor: default;
        }
      }
      .selectors {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        height: auto;
        max-height: 90px;
        overflow: hidden;
        .selector {
          padding: 0 4px;
          min-width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border-radius: 100px;
          border: 1px solid transparent;
          color: @sub;
          cursor: pointer;
          margin: 0 0 10px 4px;
        }
        .selector:first-child {
          margin: 0 0 10px 0;
        }
      }
      .overflow {
        flex-wrap: wrap;
        height: auto !important;
        overflow-y: auto;
      }
      .expander {
        width: 30px;
        height: 30px;
        border: 1px solid @dc;
        border-radius: 2px;
        margin-left: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .active {
        border-color: @green !important;
        color: @green !important;
      }
      .createBtn {
        width: 120px;
        height: 40px;
        border-radius: 100px;
        background-color: @green;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          margin-right: 10px;
        }
        &:active {
          .btnActive;
        }
        &:hover {
          .btnHover;
        }
      }
    }
  }
</style>
